import React, { FormEvent, useContext, useEffect } from "react";
import { useState } from "react";
import {Grid,Tab,Form,Input,Select,Button,Table, Confirm, Header, Segment, GridColumn, Divider, Image, Dropdown, Checkbox, CheckboxProps} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import TextareaAutosize from "react-textarea-autosize";
import MinorStore from "../../../app/stores/minorStore";
import { IProjectBog } from "../../../app/models/projectbog";

const MinorBogTab = () => {
  const minorStore = useContext(MinorStore);
  const {
    project,
    projectbogsByTime,
    loadProjectBogs,
    createProjectBog,
    deleteProjectBog,
    addProjectBog,
    updateBog,
    editProjectBog,
    techniciansByName,
    copyTechnicians,
    target,
    submitting,
  } = minorStore;

  useEffect(() => {
    loadProjectBogs(project!.id);
  }, []);

  const initialBogForm: IProjectBog = {
    id: '',
    createdAt: '',
    updatedAt: '',
    projectId: project!.id,
    bogDate: '',
    activity: '',
    technicianEmail: '',
    startTime: '',
    endTime: '',
    status: '',
    remark: ''
  };

  const [projectBog, setProjectBog] = useState<IProjectBog>(initialBogForm);
  const [openBog, setOpenBog] = useState(false);
  const [projectbogId, setProjectBogId] = useState("");

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProjectBog({ ...projectBog, [name]: value});
  };

  const technicianOptions = techniciansByName.map(function (tech) {
    var option = { "key": tech.email, "text": tech.name, "value": tech.email }
    return option;
  }
  );

  function getDayOfWeek(date: string) {
    const dayOfWeek = new Date(date).getDay();    
    return isNaN(dayOfWeek) ? null : 
      ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
  }

  const statusOptions = [{ key: "Ongoing", text: "Ongoing", value: "Ongoing" },
                    { key: "Complete", text: "Complete", value: "Complete" }];
  

  return (
    <Tab.Pane>
      <Header as='h3' textAlign='center' color='blue'>
      Boys on ground
    </Header>
      <Table celled compact  >
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Date</Table.HeaderCell>
        {/* <Table.HeaderCell>Activity</Table.HeaderCell> */}
        <Table.HeaderCell>Technician</Table.HeaderCell>
        {/* <Table.HeaderCell width='2'>Onsite Time</Table.HeaderCell> */}
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell width='2'>Remark</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {projectbogsByTime.map((projectbog, index) => (
        (projectbog.activity === 'new') ? 
        <Table.Row>
          <Table.Cell style={{width: '200px'}}>
            <Input
              name="bogDate"
              required
              type='date'
              onChange={handleInputChange}
              value={projectBog.bogDate}
              style={{width: '160px'}}
            />
            <p>{getDayOfWeek(projectBog.bogDate)}</p>
          </Table.Cell>
          {/* <Table.Cell >
          <Input
              name="activity"
              onChange={handleInputChange}
              value={projectBog.activity}
              style={{width: '150px'}}
            />
          </Table.Cell> */}
          <Table.Cell>
          <Dropdown
            name="technicianEmail"
            multiple
            search
            selection
            onChange={(e, { name, value }) => {
              setProjectBog({ ...projectBog, [name]: value });
            }}
            options={technicianOptions}
            value={projectBog.technicianEmail}
            style={{minWidth: '200px'}}
          />
          { (index === 0) &&
          <Button 
           icon='copy'
           title='Apply technicians to all BOGs'
           size='mini'
           floated='right'
           color='teal'
           onClick={() => copyTechnicians()}
          />
          }
          </Table.Cell>
          {/* <Table.Cell>
          <Input
              label='From'
              name="startTime"
              type='time'
              onChange={handleInputChange}
              value={projectBog.startTime}
            />
            <Input
              label='To&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
              name="endTime"
              type='time'
              onChange={handleInputChange}
              value={projectBog.endTime}
            />
          </Table.Cell> */}
          <Table.Cell style={{width: '120px'}}>
          <Form.Select
            onChange={(e, { name, value }) =>
              setProjectBog({ ...projectBog, [name]: value })
            }
            name="status"
            options={statusOptions}
            value={projectBog.status}
            style={{minWidth: '100px', width: '100px'}}
          />
            </Table.Cell>
          <Table.Cell>
            <Form.Field
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any) =>
              setProjectBog({ ...projectBog, ['remark']: e.currentTarget.value })
            }
          value={projectBog.remark}
          style={{border: '1px solid rgba(34,36,38,.15)'}}
        />
          </Table.Cell>
          <Table.Cell>
            <Button.Group size="mini">
              <Button
                size="mini"
                content="submit"
                color="green"
                onClick={() => createProjectBog(projectBog).then(() => setProjectBog(initialBogForm))}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
        :
        
       <Table.Row key={projectbog.id}>
          <Table.Cell style={{width: '200px'}}>
          <Input
              name="bogDate"
              transparent
              type='date'
              onChange={(e, {name, value})=> updateBog(projectbog, name, value)}
              value={projectbog.bogDate}
              style={{width: '130px'}}
            />
            <p><strong>{getDayOfWeek(projectbog.bogDate)}</strong></p>
          </Table.Cell>
          {/* <Table.Cell>
          <Input
              name="activity"
              transparent
              onChange={(e, {name, value})=> updateBog(projectbog, name, value)}
              value={projectbog.activity}
              style={{width: '150px'}}
            />
          </Table.Cell> */}
          <Table.Cell>
          <Dropdown
            name="technicianEmail"
            multiple
            search
            selection
            onChange={(e, {name, value})=> updateBog(projectbog, name, value)}
            options={technicianOptions}
            value={projectbog.technicianEmail}
            style={{minWidth: '200px', border: 'none'}}
          />
          { (index === 0) &&
          <Button 
            icon='copy'
            title='Apply technicians to all BOGs'
            size='mini'
            floated='right'
            color='teal'
            onClick={() => copyTechnicians()}
          />
          }
          </Table.Cell>
          {/* <Table.Cell>
          <Input
              name="startTime"
              label='From'
              transparent
              type='time'
              onChange={(e, {name, value})=> updateBog(projectbog, name, value)}
              value={projectbog.startTime}
            />
          <Input
              name="endTime"
              label='To&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
              transparent
              type='time'
              onChange={(e, {name, value})=> updateBog(projectbog, name, value)}
              value={projectbog.endTime}
            />
          </Table.Cell> */}
          <Table.Cell style={{width: '120px'}}>
          <Form.Select
            onChange={(e, {name, value})=> updateBog(projectbog, name, value)}
            name="status"
            options={statusOptions}
            value={projectbog.status}
            style={{minWidth: '100px', width: '100px', border: 'none'}}
          />
          </Table.Cell>
          <Table.Cell>
            <Form.Field
          control={TextareaAutosize}
          rows={1}
          onChange={(e: any)=> updateBog(projectbog, 'remark', e.currentTarget.value)}
          value={projectbog.remark}
          style={{border: 'none'}}
        />
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <Button.Group size="mini">
           { (index === projectbogsByTime.length - 1) &&
              <Button
                size="mini"
                icon="add"
                color="green"
                title="Add new"
                onClick={() => addProjectBog()}
              />}
              <Button
                size="mini"
                icon="save"
                color="blue"
                title="Save changes"
                onClick={() => editProjectBog(projectbog)}
              />
              <Button
                name={projectbog.id}
                size="mini"
                onClick={() => {
                  setOpenBog(true);
                  setProjectBogId(projectbog.id);
                }}
                icon="delete"
                color="red"
                title="Delete"
              />
              <Confirm
                open={openBog}
                onCancel={() => setOpenBog(false)}
                onConfirm={() => {
                  deleteProjectBog(projectbogId);
                  setOpenBog(false);
                }}
                content="Are you sure you want to delete ?"
                confirmButton="Yes"
                size="mini"
                style={{
                  position: "relative",
                  maxHeight: "150px",
                  height: "auto",
                }}
              />
            </Button.Group>
          </Table.Cell>
        </Table.Row>
        
      ))}
    </Table.Body>
  </Table> 
    </Tab.Pane>
  );
};

export default observer(MinorBogTab);
